import { render } from "./AiAssistantPanel.vue?vue&type=template&id=595ac73c&scoped=true"
import script from "./AiAssistantPanel.vue?vue&type=script&lang=js"
export * from "./AiAssistantPanel.vue?vue&type=script&lang=js"

import "./AiAssistantPanel.vue?vue&type=style&index=0&id=595ac73c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595ac73c"]])

export default __exports__